import { render, staticRenderFns } from "./ReservationsView.vue?vue&type=template&id=f3718bfa&scoped=true"
import script from "./ReservationsView.vue?vue&type=script&lang=js"
export * from "./ReservationsView.vue?vue&type=script&lang=js"
import style0 from "./ReservationsView.vue?vue&type=style&index=0&id=f3718bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3718bfa",
  null
  
)

export default component.exports